import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
    AddCompensationDataApi,
    getCompensationDataApi
} from 'api'
import { BoundarySlice } from 'redux/reducers'

const initialState = {
    listData: null, // 列表数据
}

/* 获取列表数据 */
export const getCompensationDataAction = createAsyncThunk(
    'CompensationSlice/getCompensationDataAction',
    async (projectId, thunkAPI) => {
        try {
            const CompensationData = await getCompensationDataApi(projectId)
            return CompensationData?.data?.data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 新增列表数据 */
export const addCompensationDataAction = createAsyncThunk(
    'CompensationSlice/addCompensationDataAction',
    async (Compensation, thunkAPI) => {
        try {
            const CompensationData = await AddCompensationDataApi(Compensation)
            return CompensationData
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

export const CompensationSlice = createSlice({
    name: 'CompensationSlice',
    initialState,
    reducers: {

    },
    extraReducers: {
        /* 获取列表数据 */
        [getCompensationDataAction.fulfilled.type]: (state, action) => {
            state.listData = action.payload
        }
    },
})
